<section class="button-detail-list-section bg-lightblue py-5" *ngIf="tabs?.length">
    <div class="container-xxxl" *ngIf="heading">
        <div class="row">
            <div class="col mb-0 mb-lg-4">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-blue border-blue">{{ heading }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <button-detail-list-larger [tabs]="tabs" [hideTabs]="hideTabs"></button-detail-list-larger>
</section>
